import { cssVariables } from "@/utils/utils";
import { Divider, Form, Select } from "antd";
import { FormItemProps } from "antd/lib/form";
import { SelectProps } from "antd/lib/select";
import t from "../../../app/i18n";
import { MarketingConsent } from "../../enums";
import AntIcon from "../icons/AntIcon";

interface Props {
  formItemProps: FormItemProps;
  selectProps?: SelectProps<MarketingConsent>;
}

const MarketingConsentSelect = ({ formItemProps, selectProps }: Props) => (
  <Form.Item {...formItemProps}>
    <Select
      {...selectProps}
      options={[
        {
          value: MarketingConsent.GRANTED,
          label: (
            <>
              <AntIcon type="check-circle-two-tone" twoToneColor={cssVariables.colorGreen} />
              <Divider orientation="vertical" />
              {t("contact.enums.marketingConsent.GRANTED")}
            </>
          ),
        },
        {
          value: MarketingConsent.NOT_GRANTED,
          label: (
            <>
              <AntIcon type="close-circle-two-tone" twoToneColor={cssVariables.colorRed} />
              <Divider orientation="vertical" />
              {t("contact.enums.marketingConsent.NOT_GRANTED")}
            </>
          ),
        },
      ]}
    />
  </Form.Item>
);

export default MarketingConsentSelect;
